import React from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { EntityDataEditorProps } from './EntityDataEditor.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const EntityDataEditor = (props: EntityDataEditorProps) => {
  const { entityOptions } = useCashFlowContext();

  return <GridSelect menuPosition="fixed" usePortal options={entityOptions} {...props} />;
};

export default EntityDataEditor;
